import { FunctionComponent } from 'react';
import styled from 'styled-components';
import { XCloseIcon } from '@rsos/assets/icons';
import { AttentionTriangleIcon } from '@rsos/assets/icons';
import { Box, Text, Absolute } from '@rsos/components/capstone/base';

interface WrapperContainerProps {
  error?: string;
}

interface LiTagContainerProps {
  isValid: boolean;
  hasIcon: boolean;
}

interface InputContainerProps {
  hasPrefixComponent: boolean;
}

export const WrapperContainer = styled(Box).attrs({
  bg: 'background',
  borderRadius: 5,
  height: 74,
  horizontal: true,
  align: 'baseline',
  overflow: 'auto',
})<WrapperContainerProps>`
  border: ${p =>
    p.error
      ? `1px solid ${p.theme.colors.lightDanger}`
      : `1px solid ${p.theme.colors.heavyLineOutline}`};
  padding: 5px 5px 0;
  &:focus-within {
    border-color: ${p =>
      p.error ? p.theme.colors.lightDanger : p.theme.colors.primaryBase};
  }
`;

export const ULTagContainer = styled.ul`
  margin: 0;
  padding: 0;
  width: 100%;
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
  overflow: auto;
`;

export const LiTagContainer = styled.li<LiTagContainerProps>`
  align-items: center;
  font-size: 12px;
  height: 22px;
  background: ${p => (p.isValid ? p.theme.colors.foreground : 'inherit')};
  border-radius: ${p => (p.isValid ? '10px' : 'none')};
  color: ${p => p.theme.colors.secondaryText};
  display: flex;
  text-decoration: ${p => (p.isValid ? 'none' : 'underline dotted red')};
  list-style: none;
  margin-bottom: 5px;
  margin-right: 5px;
  margin-left: ${p => (p.isValid ? '5px' : 0)};
  padding: 0 23px 0 ${p => (p.hasIcon ? '6px' : '8px')};
  position: relative;
  gap: 4px;
`;

export const InputContainer = styled(Box).attrs<InputContainerProps>(
  ({ hasPrefixComponent }) => ({
    align: 'center',
    mb: '5px',
    mr: '5px',
    padding: hasPrefixComponent ? '10px 10px 10px 4px' : 10,
  }),
)<InputContainerProps>`
  flex-grow: 1;
`;

export const StyledMultiEntryTextArea = styled.textarea`
  background: none;
  color: ${p => p.theme.colors.secondaryText};
  width: 100%;
  font-size: 12px;
  border: none;
  resize: none;
  &::placeholder {
    color: ${p => p.theme.colors.secondaryText};
  }
  &:focus {
    outline: none;
  }
  &:disabled {
    width: 0;
  }
`;

export const InputTextLabel = styled(Text).attrs({
  size: 'normal',
  color: 'primaryText',
  mb: '8px',
})``;

interface ClearIconComponentProps {
  onClick: () => void;
}

export const ClearIconComponent: FunctionComponent<ClearIconComponentProps> = ({
  onClick,
}) => {
  return (
    <Absolute
      top={0}
      bottom={0}
      center
      width="16px"
      right={0}
      onClick={onClick}
      style={{ cursor: 'pointer' }}
    >
      <XCloseIcon width={9} height={9} />
    </Absolute>
  );
};

interface ErrorComponentProps {
  error: string;
}

export const ErrorComponent: FunctionComponent<ErrorComponentProps> = ({
  error,
}) => {
  return (
    <Box horizontal flow={5} color="lightDanger" mt="8px">
      <AttentionTriangleIcon height={12} width={12} />
      <Text size="small" color="lightDanger">
        {error}
      </Text>
    </Box>
  );
};
